import {
  Empty,
  message,
  Modal,
  Select,
  Input,
  DatePicker,
  Row,
  Col,
  Button,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { AppTable } from '../../components/AppTable/AppTable'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import {
  QuestionCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import {
  TYPE_STATUS,
  PROPOSAL_STATUS,
  YYYY_MM_DD,
  ASSIGNEE_TYPE,
  ACL_ACTION_TYPE,
} from '../../constants'
import { TableBottomPaginationBlock } from '../../components/Common/Table'
import { StatusTag } from '../../components/Common/StatusTag'
import { AvatarHasName } from '../../components/Common/Avatar'
import moment from 'moment'
import DistributionVotesUpdate from './DistributionVotesUpdate'
import debounce from 'lodash/debounce'
import DistributionVotesUpdateDetails from './DistributionVotesDetail/DistributionVotesUpdateDetails'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import pickBy from 'lodash/pickBy'
import { Pen2OutlineIcon, TrashBin2OutlineIcon } from '../../components/AppIcon'
import { blue } from '../../color'

const { Option } = Select
const stylePagination = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 20,
  marginBottom: 10,
}

const { confirm } = Modal

const DistributionVotesList = props => {
  const [isLoading, setIsLoading] = useState(false)
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [keyword1, setKeyword] = useState(null)
  const [createUser1, setCreateUser1] = useState(null)
  const [enter, setEnter] = useState(true)
  const [date, setDate] = useState(null)

  const {
    selectPeopleStore,
    authenticationStore,
    isVisibleCreateModal,
    aclStore,
    DistributionVotesStore,
    proposalAdvanceStore,
  } = props
  const { originDepartmentWithUserList, companyCode } = selectPeopleStore
  const { isAccountAdmin } = authenticationStore
  const { totalCountProposal, checkVotes } = DistributionVotesStore

  const [selectedTemplateId, setSelectedTemplateId] = useState({})

  const history = useHistory()
  const location = useLocation()

  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  // useEffect(() => {
  //   ;async () => {
  //     await DistributionVotesStore.getDistributionVotesDetail(
  //       selectedTemplateId
  //     )
  //   }
  //   ;async () => {
  //     await proposalAdvanceStore.getProposalAdvanceList()
  //   }
  // }, [])

  // useEffect(() => {
  //   ;(async () => {
  //     if (checkVotes) {
  //       await setKeyword(keyword)
  //       await setCreateUser1(createUser)
  //       await DistributionVotesStore.setFilter('checkVotes', false)
  //     } else {
  //       await DistributionVotesStore.clearFilterProposal()
  //     }
  //     // await loadDistributionVotesList()
  //   })()
  // }, [])

  useEffect(() => {
    ;(async () => {
      if (companyCode) {
        try {
          await selectPeopleStore.getDepartmentWithUsers()
        } catch (err) {
          console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const loadDistributionVotesList = async () => {
    try {
      setIsLoading(true)
      const queryParams = {
        page: queryStringParse?.page || 0,
        size: queryStringParse?.size || 10,
        keyword: queryStringParse?.keyword || null,
        proposal_status: queryStringParse?.proposal_status,
        create_user: queryStringParse?.create_user,
        created_at: queryStringParse?.created_at,
        proposal_permission: queryStringParse?.proposal_permission,
      }
      const formattedQueryPayload = pickBy(queryParams, v => v != null)
      await DistributionVotesStore.getDistributionVotestList(
        queryString.stringify(formattedQueryPayload)
      )
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    void loadDistributionVotesList()
  }, [queryStringParse])

  const handleDelete = async code => {
    try {
      setIsLoading(true)
      await DistributionVotesStore.delete(code)
      message.success('Đã xóa!')
      await loadDistributionVotesList()
    } catch (err) {
      console.log(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoading(false)
    }
  }

  const handleToggleCreateModal = bool => event => {
    setIsVisibleUpdateModal(bool)
    loadDistributionVotesList()
  }

  const showConfirm = code => {
    confirm({
      title: 'Bạn có chắc chắn muốn xóa không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Xóa',
      cancelText: 'Không',
      okType: 'danger',
      onOk: async () => {
        await handleDelete(code)
      },
    })
  }

  const handleOpenUpdateModal = id => event => {
    // props.managementAssetWarehouseStore.clearManagementAssetWarehouseDetail()
    setIsVisibleUpdateModal(true)
    setSelectedTemplateId(id)
  }

  const tableColumns = [
    {
      title: 'Nội dung',
      render: record => <p>{record.title}</p>,
      width: 450,
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    {
      title: 'Ngày tạo',
      width: 100,
      align: 'center',
      render: record => {
        const date = new Date(record?.create_at || 0)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')

        const formattedDate = `${day}/${month}/${year}`
        return <p style={{ marginBottom: '0px' }}>{formattedDate}</p>
      },
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    {
      title: () => <div style={{}}>Người tạo</div>,
      // align: 'center',
      width: 150,
      render: record => (
        <div style={{ display: 'flex', textTransform: 'capitalize' }}>
          {record?.create_user?.name_lowercase}
        </div>
      ),
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    {
      title: 'Trạng thái',
      align: 'center',
      render: record => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {StatusTag(TYPE_STATUS.PROPOSAL, record.proposal_status)}
        </div>
      ),
      width: 150,
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
  ]
  const tableColumnsTi = [
    {
      title: 'Nội dung',
      render: record => {
        return (
          <div style={{ display: 'flex', alignContent: 'center' }}>
            {record.title}
          </div>
        )
      },
      width: 450,

      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    {
      title: 'Ngày tạo',
      width: 100,
      align: 'center',
      render: record => {
        const date = new Date(record?.created_at || 0)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')

        const formattedDate = `${day}/${month}/${year}`
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
            }}>
            {formattedDate}
          </div>
        )
      },
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    {
      title: () => <div style={{}}>Người tạo</div>,
      // align: 'center',
      width: 150,
      render: record => (
        <div style={{ display: 'flex', textTransform: 'capitalize' }}>
          {record?.create_user?.name_lowercase}
        </div>
      ),
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    {
      title: 'Trạng thái',
      align: 'center',
      render: record => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {StatusTag(TYPE_STATUS.PROPOSAL, record.proposal_status)}
        </div>
      ),
      width: 150,
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(
              `/distribution-votes/other/view/${record.proposal_code}`
            )
          },
        }
      },
    },
    // {record &&
    //     (aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__PROPOSAL__ASSET) ||
    //         isAccountAdmin ||
    //         checkAccessControlUpdateAction())
    // }
    // },
    {
      title: 'Thao tác',
      align: 'center',
      width: 100,
      render: record => (
        <div style={{ display: 'flex', placeContent: 'center' }}>
          {record &&
            (aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.edit__PROPOSAL__ASSET
            ) ||
              isAccountAdmin ||
              checkAccessControlUpdateAction()) && (
              <Button
                shape="circle"
                type="text"
                icon={
                  <Pen2OutlineIcon
                    style={{
                      width: '16px',
                      height: '16px',
                      color: blue,
                    }}
                    onClick={handleOpenUpdateModal(record.proposal_code)}
                  />
                }
              />
            )}
          {record &&
            (aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.delete__PROPOSAL__ASSET
            ) ||
              isAccountAdmin ||
              checkAccessControlUpdateAction()) && (
              <Button
                shape="circle"
                type="text"
                icon={
                  <TrashBin2OutlineIcon
                    style={{ color: '#fc0000', width: '16px', height: '16px' }}
                    onClick={() => showConfirm(record.proposal_code)}
                  />
                }
              />
            )}
        </div>
      ),
    },
  ]

  const checkAccessControlUpdateActionV2 = record => {
    return record?.approval_levels?.some(
      item => item.username === authenticationStore?.currentUser?.username
    )
  }
  const checkAccessControlUpdateAction = record => {
    return (
      authenticationStore?.currentUser?.username ===
      record?.create_user?.user_name
    )
  }

  const handleChangePageProposalLeave = (pageIndex, size) => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: pageIndex - 1,
        size: size,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/distribution-votes?${queryStringStringify}`)
  }

  return (
    <>
      <AppTable
        rowKey={record => record.code}
        dataSource={DistributionVotesStore.distributionVotesList}
        columns={
          !(
            aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.edit__PROPOSAL__ASSET
            ) ||
            isAccountAdmin ||
            checkAccessControlUpdateAction()
          ) &&
          !(
            aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.delete__PROPOSAL__ASSET
            ) ||
            isAccountAdmin ||
            checkAccessControlUpdateAction()
          )
            ? tableColumns
            : tableColumnsTi
        }
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />

      <AppTablePagination
        onChange={handleChangePageProposalLeave}
        total={totalCountProposal}
        pageSize={Number(queryStringParse?.size || 10)}
        current={Number(queryStringParse?.page || 0) + 1}
      />

      <Modal
        width={1000}
        title={'Chỉnh sửa'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose
        wrapClassName="custom-modal-wrapper">
        {isVisibleUpdateModal && (
          <DistributionVotesUpdateDetails
            templateId={selectedTemplateId}
            onCancel={handleToggleCreateModal(false)}
            btn="Cập nhật"
            check={false}
          />
        )}
      </Modal>
    </>
  )
}

export default inject(
  'aclStore',
  'DistributionVotesStore',
  'authenticationStore',
  'selectPeopleStore',
  'managementAssetWarehouseStore'
)(observer(DistributionVotesList))
